import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// CDN 아이콘을 직접 사용하여 기본 아이콘 문제를 회피합니다.
const DefaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;

// Map 클릭 후 핀을 추가하고 위치를 부모로 알리는 훅
function ClickHandler({ onClick }) {
  useMapEvents({
    click(e) {
      onClick(e.latlng);
    }
  });
  return null;
}

export default function MapComponent({ center = [36, 128], zoom = 7, markers = [], onMapClick, onMarkerClick, mapHeight = '60vh' }) {
  const mapRef = useRef();

  useEffect(() => {
    if (mapRef.current) {
      // 추가 작업 가능
    }
  }, []);

  return (
    <div className="map-container">
      <MapContainer center={center} zoom={zoom} style={{ height: mapHeight, width: '100%' }} ref={mapRef}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <ClickHandler onClick={(latlng) => onMapClick && onMapClick(latlng)} />

        {markers.map((m) => (
          <Marker key={m.id || `${m.lat}-${m.lng}`} position={[m.lat, m.lng]} eventHandlers={{ 
            click: ()=>{ 
              // 포인트 페이지에서만 클릭 기록 (id가 문자열이고 타임스탬프가 아닌 경우)
              if (m.id && typeof m.id === 'string' && !Number.isFinite(m.id)) {
                fetch('/api/points/click',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({ pointId: m.id })}).catch(()=>{});
              }
              if (onMarkerClick) onMarkerClick(m);
            }
          }}>
            <Popup>
              <div style={{minWidth:200}}>
                {m.image && (
                  <div style={{marginBottom:8}}>
                    <img src={m.image} alt={m.title} style={{width:'100%', maxWidth:250, height:150, objectFit:'contain', borderRadius:4}} />
                  </div>
                )}
                <strong>{m.title || m.id}</strong>
                <div>{m.desc}</div>
                {m.url && <div style={{marginTop:8}}><a href={m.url} target="_blank" rel="noopener noreferrer" style={{color:'#0077be',textDecoration:'underline'}}>블로그 보기 →</a></div>}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
